import { Component, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Inject, NgModule, Input } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
// patrones de enrutamiento interno
import { ActivatedRoute, Router } from '@angular/router';
// par ausar formularios contiene formGroup y formcontrol
import { FormGroup, FormControl, FormArray, Validators} from '@angular/forms';
// Modelos
import { Estancia } from '../../../models/estancia';
// Servicios
import { EstanciasService } from '../../../services/estancias.service';

import { Observable, } from 'rxjs';
import { map } from 'rxjs/operators';

import { AgFileUploadComponent } from '../../ag-file-upload/ag-file-upload.component';
import { FileBrowserComponent } from '../../file-browser/file-browser.component';
import { AuthService } from '../../../services/auth.service';
import { TasacionArchivo} from '../../../models/TasacionArchivo';
import { TasacionesService } from '../../../services/tasaciones.service';
import { TasacionArchivoValues } from '../../../models/enums';
import { VisitasService } from '../../../services/visitas.service';
import { GlobalUIUtilsService } from '../../../services/global-ui-utils.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-estancias-edit',
  templateUrl: './estancias-edit.component.html',
  styleUrls: ['./estancias-edit.component.scss']
})
export class EstanciasEditComponent implements OnInit, OnChanges {

  @Input() idTasacion?: number;
  @Input() version?: number;
  @Input() IdEstancia?: number;

  public estancia: Estancia;
  title: string;
  form: FormGroup;

  tiposEstancias: Map<string, string>;
  ficherosVisitaEstanciaList: Observable<TasacionArchivo[]>;
  needRefreshArchivos = false;
  selectedFile: ImageSnippet;
  Titulo = 'Fotos';
  message = this.translate.instant('comunes.toastr_guardado');

  @Input() mode: string;
  @Output() exit = new EventEmitter();

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    @Inject('BASE_URL')
    private baseUrl: string,
    public _authService: AuthService,
    public _TasacionesService: TasacionesService,
    private visitaService: VisitasService,
    private estanciasService: EstanciasService,
    private _GlobalUIUtilsService: GlobalUIUtilsService, 
    private translate: TranslateService ) { }

  ngOnInit() {

    this.estanciasService.getTipoEstancia().subscribe((res: Map<string, string>) => this.tiposEstancias = res);

    this.form = new FormGroup({
      tipoEstancia: new FormControl(''),
      tieneVentana: new FormControl(''),
      ventanaExterior: new FormControl(''),
      superficie: new FormControl('', [Validators.pattern('^[0-9]*$')])
    });
    
    if(this.mode == 'not-edit') {
      this.form.disable();
    }

    console.log('cargar datos');
    this.loadData();
    console.log('cargar imagenes');
    this.needRefreshArchivos = true;
    this.refreshArchivosEstancia();
    console.log('Todo cargado');
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.comprobarChecks();
    this.loadData();
  }


  changeInput() {
    console.log('Guardando...');
    this.save();
    this.comprobarChecks();
  }

  comprobarChecks() {
    if(this.mode != 'not-edit') {
      console.log('comprbando check');
      if (this.estancia != null) {
        if (this.estancia.tieneVentana === false){
          this.form.get('ventanaExterior').disable();
        } else {
          this.form.get('ventanaExterior').enable();
        }
      }
    }
  }

  onSubmit() {
    this.save();
    const url = `${this.baseUrl}api/VisitaEstancias/${this.estancia.idTasacion}/${this.estancia.idVisitaVersion}/${this.estancia.idEstancia}`;
    // go back to cities view
    this.router.navigate([url]);
  }

  save() {

    const estancia = (this.IdEstancia && this.version && this.idTasacion) ? this.estancia : null;
    if(estancia != null)
    {
      estancia.superficie = this.form.get('superficie').value;
      estancia.tieneVentana = this.form.get('tieneVentana').value;
      estancia.ventanaExterior = this.form.get('ventanaExterior').value;
      estancia.tipoEstancia = +this.form.get('tipoEstancia').value;

      console.log(this.estancia);
      if (this.IdEstancia && this.version && this.idTasacion) {
        // EDIT mode
        const url = `${this.baseUrl}api/VisitaEstancias/${this.estancia.idTasacion}/${this.estancia.idVisitaVersion}/${this.estancia.idEstancia}`;
        this.http
          .put<Estancia>(url, estancia)
          .subscribe(result => {
            console.log( `Estancia ${estancia.idTasacion} has been updated.`);
            this._GlobalUIUtilsService.success(this.message);
          }, error => console.log(error));
      } else {
        console.error('No puedes crear una visitas nueva.');
      }
      console.log('Datos guardados.');
    }
    else
    {
      console.log('Estancia no se guardo: es null');
    }

  }

  loadData() {

    console.log('Editar estancia.');
    // retrieve the ID from the 'id' parameter
    if(this.mode != 'not-edit') {
      this.cargarVariablesUrl();
    }
    if (this.idTasacion && this.version && this.IdEstancia)
    {  // EDIT MODE
        
      console.log("buscando estancia en BBDD.");
      this.estanciasService.get(this.idTasacion, this.version, this.IdEstancia).subscribe(
        result =>
        {
          this.estancia = result;
          console.log("Cargando la estancia.");
          console.log(this.estancia);
          this.title = 'Editar';
          this.form.patchValue(this.estancia);
          this.comprobarChecks();
        },
        error =>
        {
          console.log("no se ha leido de la BBDD.");
          console.error(error);
        }
      );
    } else { // ADD NEW MODE
      // No se pueden generar nuevas visitas desde este modulo
      console.log("Noooooooooooooo");
      // this.router.navigate([`/visitas{}`]);
    }

  }

  volver_estancias() {
    this.router.navigate([`visita/${this.idTasacion}/${this.version}/step6`]);
  }

  private cargarVariablesUrl() {
    this.idTasacion = +this.activatedRoute.snapshot.paramMap.get('id');
    this.version = +this.activatedRoute.snapshot.paramMap.get('version');
    if (this.activatedRoute.snapshot.paramMap.keys.includes('idEstancia')) {
      this.IdEstancia = +this.activatedRoute.snapshot.paramMap.get('idEstancia');
    }

    console.log(this.activatedRoute.snapshot.paramMap.keys);
    console.log('this.idTasacion: ' + this.idTasacion);
    console.log('this.version; ' + this.version);
    console.log('this.IdEstancia: ' + this.IdEstancia);
  }

  onFileUploadedEstancia(event, idEstancia) {
    this.needRefreshArchivos = true;
    this.refreshArchivosEstancia();
  }

  FileDelete(TasacionArchivoID, idEstancia) {
      this._TasacionesService.removeArchivoTasacion(TasacionArchivoID).subscribe(data => {
      this.needRefreshArchivos = true;
      this.refreshArchivosEstancia();
    });
  }

  eliminarEstancia()
  {
    this.estanciasService.delete(this.estancia).subscribe(res => console.log(res));
    this.volver_estancias();
  }

  refreshArchivosEstancia() {
    console.log('actualziando imagenes estancia.');
    if (this.needRefreshArchivos) {
      console.log('refresh');
      if (this.idTasacion !== undefined) {
        const svcGeneric = this.visitaService.getFicherosVisita(this.idTasacion, this.version, this.IdEstancia);
        this.ficherosVisitaEstanciaList = svcGeneric.pipe(
          map( (d) => {
            return d.filter( d2 => d2.tipoArchivo === TasacionArchivoValues.Fotos);
          }
        ));
        this.needRefreshArchivos = false;
      } else {
        console.log('no refesh');
      }
    }
  }
}

class ImageSnippet {
  constructor(public src: string, public file: File) {}
}
